import $ from "jquery";

$(window).scroll(function () {
  var body = $("body");
  var top = 30;
  if ($(window).scrollTop() >= top) {
    body.addClass("scroll");
  } else {
    body.removeClass("scroll");
  }
});
